<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-monitoramento
      :acesso="acesso"
      monitoramento="desempenho"
      titulo="Desempenho Técnico"
    >
      <template v-slot:body>
        <!-- Usuário não é da comissão e o desempenho ainda não iniciou -->
        <v-col v-if="desempenhoNaoDisponivel">
          <app-alert
            :message="mensagemDesempenhoNaoDisponivel"
            type="info"
          />
        </v-col>

        <!-- Diagnóstico iniciou -->
        <v-col
          v-else
          centered
          cols="12"
          no-gutters
        >
          <!-- tabs -->
          <v-row class="justify-center ma-2">
            <v-tabs
              v-model="currentCategoriaId"
              centered
              icons-and-text
            >
              <v-tabs-slider color="secondary" />
              <v-tab
                v-for="c in categorias"
                :key="c.id"
                :href="'#' + c.id"
                class="mt-3"
              >
                <span class="grey--text text--darken-2">{{ c.descricao }}</span>
                <v-icon
                  :color="c.id === currentCategoria.id ? 'secondary' : 'grey'"
                >
                  {{ c.icone }}
                </v-icon>
              </v-tab>
            </v-tabs>
          </v-row>

          <!-- current component -->
          <v-row class="justify-center ma-2">
            <v-col v-if="loaded">
              <keep-alive>
                <component
                  :is="currentComponent"
                  :key="currentCategoria.id"
                  :tipo="currentCategoria.id"
                  :diagnostico="diagnostico"
                />
              </keep-alive>
            </v-col>
          </v-row>
        </v-col>
      </template>
    </app-monitoramento>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppMonitoramento from '@/components/core/AppMonitoramento';
import AppAlert from '@/components/core/AppAlert';
import ResultadoServidoresResponsabilidade
from '@/views/monitoramento/desempenho/responsabilidade/tabs/ResultadoServidoresResponsabilidade';
import RelatorioGerencialResponsabilidadeGeral
from '@/views/monitoramento/desempenho/responsabilidade/tabs/RelatorioGerencialResponsabilidadeGeral';
import RelatorioGerencialResponsabilidadeUnidade
from '@/views/monitoramento/desempenho/responsabilidade/tabs/RelatorioGerencialResponsabilidadeUnidade';
import Data from '@/modules/data';

export default {
  name: 'MonitoramentoDesempenhoResponsabilidade',

  components: {
    AppMonitoramento,
    AppAlert,
    ResultadoServidoresResponsabilidade,
    RelatorioGerencialResponsabilidadeGeral,
    RelatorioGerencialResponsabilidadeUnidade,
  },

  data() {
    return {
      acesso: null,
      currentCategoriaId: null,
    };
  },

  computed: {
    ...mapState({
      isTutorialExibido: (state) => state.tutorial.dados.monitoramentoDesempenhoResponsabilidade,
      unidade: (state) => state.auth.unidade,
      comissao: (state) => state.auth.comissao,
      usuario: (state) => state.auth.usuario,
      chefia: (state) => state.auth.chefia,
      substituicaoChefia: (state) => state.auth.substituicaoChefia,
      loaded: (state) => state.monitoramentoDesempenho.loaded,
    }),
    ...mapGetters({
      getDiagnostico: 'diagnostico/getDiagnostico',
      getUnidadesByAcesso: 'unidade/getUnidadesByAcesso',
    }),
    diagnostico() {
      return this.getDiagnostico(this.acesso);
    },
    desempenhoNaoDisponivel() {
      // Retorna verdadeiro se o usuário não for da comissão e o desempenho ainda não tiver iniciado
      // Se for da comissão os dados de desempenho poderam ser acessados
      return this.acesso === 'COMUM'
        && this.diagnostico && Data.compare('isBefore', { b: this.diagnostico.inicioDesempenho });
    },
    mensagemDesempenhoNaoDisponivel() {
      return `Desempenho ainda não disponível. Início em ${Data.format(this.diagnostico.inicioDesempenho)}.`;
    },
    categorias() {
      const categorias = [
        {
          id: 'SERVIDORES',
          descricao: 'Resultado dos Servidores',
          component: 'ResultadoServidoresResponsabilidade',
          icone: 'group',
        },
        {
          id: 'RELATORIOS_UNIDADE',
          descricao: 'Relatórios Gerenciais por Unidade',
          component: 'RelatorioGerencialResponsabilidadeUnidade',
          icone: 'account_balance',
        },
      ];
      if (this.unidades.length > 1 || this.acesso === 'COMISSAO') {
        categorias.splice(1, 0, {
          id: 'RELATORIOS',
          descricao: 'Relatórios Gerenciais',
          component: 'RelatorioGerencialResponsabilidadeGeral',
          icone: 'account_balance',
        });
      }
      return categorias;
    },
    currentComponent() {
      return this.currentCategoria.component || '';
    },
    currentCategoria() {
      return this.categorias.find((c) => c.id === this.currentCategoriaId) || {};
    },
    unidades() {
      return this.getUnidadesByAcesso(this.acesso, this.diagnostico.mapeamento.id);
    },
  },

  watch: {
    diagnostico() {
      if (!this.desempenhoNaoDisponivel) {
        const payload = {
          comissao: this.comissao,
          unidade: this.unidade,
          diagnostico: this.diagnostico,
        };
        this.$store.dispatch('monitoramentoDesempenho/load', payload);
      }
    },
  },

  created() {
    if (this.comissao) {
      this.acesso = 'COMISSAO';
    } else if (this.chefia || this.substituicaoChefia) {
      this.acesso = 'COMUM';
    }

    if (!this.isTutorialExibido && this.acesso) {
      let tutorial = '';
      if (this.unidades.length > 1 || this.acesso === 'COMISSAO') {
        tutorial = 'MonitoramentoDesempenhoGeralResponsabilidade';
      } else {
        tutorial = 'MonitoramentoDesempenhoUnidadeResponsabilidade';
      }
      this.$store.dispatch('app/showTutorial', {
        nome: tutorial,
        nomeGenerico: 'MonitoramentoDesempenhoResponsabilidade',
      });
    }
  },
};
</script>
